import React from 'react';
import { useClients } from '@/hooks/use-clients';
import { Card } from '@/components/ui/card';

export function ClientsSection() {
    const { data: clients = [], isLoading } = useClients();

    if (isLoading) {
        return (
            <section className="py-24 bg-black/20">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className="h-32 bg-white/5 rounded-xl animate-pulse" />
                        ))}
                    </div>
                </div>
            </section>
        );
    }

    // If no clients, don't render section
    if (!clients || clients.length === 0) return null;

    return (
        <section className="py-24 relative overflow-hidden">
            {/* Background Elements */}
            <div className="absolute inset-0 bg-background/50" />
            <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" />

            <div className="container mx-auto px-4 relative z-10">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-5xl font-bold mb-4 text-white">
                        Clientes & <span className="text-blue-500">Parceiros</span>
                    </h2>
                    <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-light">
                        Tenho o privilégio de trabalhar com marcas incríveis e pessoas inspiradoras
                    </p>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
                    {clients.map((client) => (
                        <Card
                            key={client.id}
                            className="group relative h-40 bg-black/40 border-white/5 hover:border-blue-500/30 transition-all duration-500 overflow-hidden flex items-center justify-center p-6"
                        >
                            {/* Glow Effect */}
                            <div className="absolute inset-0 bg-blue-500/0 group-hover:bg-blue-500/5 transition-colors duration-500" />

                            <img
                                src={client.logo}
                                alt={client.name}
                                className="w-full h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-500 opacity-60 group-hover:opacity-100 transform group-hover:scale-110"
                                title={client.name}
                            />
                        </Card>
                    ))}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" />
        </section>
    );
}
